export default __webpack_public_path__ + "static/media/Backrooms.f2f765c4.mp3";